import { useState } from 'react';
import { useEffect } from 'react';
import globalEvents from '@/utils/globalEvents';
import Button from '@/components/Button';
import ModalHoc from '@/components/ModalHoc';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultOptions = Object.freeze({
  id: 'confirmation-prompt',
  title: 'Are you sure?'
});

const ConfirmationPrompt = () => {
  const {
    0: isVisible,
    1: setVisible
  } = useState(false);
  const {
    0: options,
    1: setOptions
  } = useState(defaultOptions); // Subscribe to global events

  useEffect(() => {
    return globalEvents.subscribe('confirmationPromptOpen', evt => {
      if (evt !== null && evt !== void 0 && evt.detail) setOptions(evt === null || evt === void 0 ? void 0 : evt.detail);
      setVisible(true);
    });
  }, []); // Trigger global event on close
  // with the confirmation status

  const closePrompt = confirm => {
    globalEvents.trigger('confirmationPromptClose', {
      detail: {
        id: options.id,
        confirm
      }
    });
    setOptions(defaultOptions);
    setVisible(false);
  };

  return /*#__PURE__*/_jsx(ConfirmationPromptModal, {
    isVisible: isVisible,
    title: options.title,
    onCancel: () => closePrompt(false),
    onSave: () => closePrompt(true)
  });
};

const ConfirmationPromptBody = _ref => {
  let {
    title,
    onCancel,
    onSave
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.message,
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.actions,
      children: [/*#__PURE__*/_jsx(Button, {
        type: "button",
        variant: 'gray',
        onClick: () => onCancel(),
        children: "Discard"
      }), /*#__PURE__*/_jsx(Button, {
        type: "button",
        variant: "primary",
        onClick: () => onSave(),
        children: "Save Changes"
      })]
    })]
  });
};

const ConfirmationPromptModal = ModalHoc(ConfirmationPromptBody, {
  modalClass: styles.modal,
  overlayclass: styles.overlay,
  hasCloseButton: false,
  closeOnOverlayClick: false
});
export default ConfirmationPrompt;